import i from "./createDomainForCookie.mjs";
import r from "./hasConsentedToOldVersion.mjs";
import t from "./setConsentedPolicyVersion.mjs";
const c = async () => {
  const o = await Promise.resolve(window.latestPolicyVersionPromise);
  if (typeof o != "number" && typeof o < "u")
    throw new Error(`latestPolicyVersion is invalid ${String(o)}`);
  if (r({
    latestPolicyVersion: o
  })) {
    const e = "Thu, 01 Jan 1970 00:00:01 GMT";
    document.cookie = `cmapi_cookie_privacy=; expires=${e}; domain=${i()}; path=/`, await t({
      expires: e
    });
  }
};
export {
  c as default
};
